import { Badge } from '@/components/ui'
import { cn } from '@/lib/utils'
import { AlertTriangle } from 'lucide-react'

export function TargetInactiveBadge({ className }: { className?: string }) {
  return (
    <Badge
      variant="outline"
      className={cn('bg-warning text-warning-foreground border-warning-foreground gap-1', className)}
      data-testid="schedule-target-inactive-badge"
    >
      <AlertTriangle className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      Workflow deactivated
    </Badge>
  )
}
